import { render } from "./type-title.vue?vue&type=template&id=da77786e&lang=pug"
import script from "./type-title.vue?vue&type=script&lang=js"
export * from "./type-title.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__